"use client";

import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";

const REQUIREMENT_COUNT = 5;

export default function ActionRequirementsModalSkeleton() {
  return (
    <div className="px-5 py-5 sm:px-6 sm:py-6 space-y-4">
      <DialogHeader className="text-left space-y-4">
        <DialogTitle className="text-center text-xl sm:text-2xl font-bold text-foreground leading-tight">
          <Skeleton className="h-8 w-3/4 mx-auto" />
        </DialogTitle>
        <DialogDescription
          className="text-left text-base text-ink-emphasis"
          asChild
        >
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-11/12" />
          </div>
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-4">
        <div>
          <div className="bg-surface-subtle rounded-lg border border-border p-4 space-y-3">
            <Skeleton className="h-5 w-56 mb-3" />
            {Array.from({ length: REQUIREMENT_COUNT }).map((_, i) => (
              <div
                key={i}
                className="flex items-start gap-3 text-base text-ink-emphasis"
              >
                <Skeleton className="w-5 h-5 mt-0.5 shrink-0 rounded" />
                <Skeleton className="h-4 flex-1" />
              </div>
            ))}
          </div>
        </div>

        <Skeleton className="h-4 w-64 mx-auto" />
      </div>

      <DialogFooter className="flex-col gap-2 sm:flex-col">
        <Skeleton className="w-full h-11 rounded-lg" />
        <Skeleton className="w-full h-11 rounded-lg" />
      </DialogFooter>
    </div>
  );
}
